import React, { Component } from 'react';
import { Table, Button, message } from 'antd';
import SiteTemplate from '../../common/siteTemplate';
import ExportUtil from '../../../common/ExportUtil';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import SideNav from '../SideNav';

class SiteClose extends Component {
    state = {
        curRole: '',
        isSite: false,
        sortParams: {},
        pagination: {
            current: 1,
            pageSize: 10,
        },
        loading: false,
        edit: false,
        cancelStr: '',
    }

    componentDidMount() {
        const isSite = sessionStorage.siteId == 0;
        this.setState({
            curRole: sessionStorage.curRole,
            isSite,
        }, () => {
            isSite ? this.loadTableData() : this.queryHospital();
        });
        this.queryInvestigationStageByInvId();
    }

    queryHospital = () => {
        const options = {
            method: 'POST',
            url: `${API_URL.invStartUp.queryInvestigationSiteById}`,
            data: {
                siteId: sessionStorage.siteId,
            },
            dataType: 'json',
            doneResult: res => {
                this.setState({
                    hospitalId: res.data.hospitalId,
                    hospitalName: res.data.investigationSiteName,
                    cancelStr: res.data.cancelStr,
                });
            },
        };
        $.sendRequest(options);
    }

    loadTableData = () => {
        const { sortParams, pagination } = this.state;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: `${API_URL.invShutOff.queryInvestigationSiteClose}`,
            data: {
                limit: pagination.pageSize,
                offset: pagination.current,
                ...sortParams,
            },
            dataType: 'json',
            doneResult: res => {
                pagination.total = res.data.totalCount;
                this.setState({
                    pagination,
                    loading: false,
                    data: res.data.datas,
                    treeData: res.treeData,
                });
            },
        };
        $.sendRequest(options);
    }

    queryInvestigationStageByInvId = () => {
        const { invId: investigationId } = sessionStorage;
        const options = {
            method: 'POST',
            url: API_URL.investigation.queryInvestigationStageByInvId,
            data: { investigationId },
            dataType: 'json',
            doneResult: res => {
                const { data } = res;
                this.setState({
                    invStageList: data,
                });
            },
        };
        $.sendRequest(options);
    }

    canEditByInvStatus = (callback) => {
        const { invStageList: data = [] } = this.state;
        const canEdit = !(data || []).some(i => {
            if (i.operation === 'INVESTIGATION_LEVEL_LOWEST') {
                message.error('项目到达“项目终止”阶段，不可调整项目相关数据！');
                return true;
            } else if (i.operation === 'INVESTIGATION_DATA_LOCK') {
                message.error('项目到达“项目关闭”阶段，不可调整项目相关数据！');
                return true;
            } else if(i.operation === 'TERMINATED_BEFORE_CONTRACT'){
                message.error('项目已在服务合同签署前终止，不可调整项目相关数据');
                return true;
            } else if (i.operation === 'BUSINESS_DATA_ARCHIVING') {
                message.error('项目到达“业务数据归档”阶段，不可编辑项目相关数据');
                return true;
            }
            return false;
        });
        if (canEdit) {
            callback();
        }
    }

    getColumns = () => {
        const { curRole, treeData = [] } = this.state;
        const columns = [{
            title: '中心编号',
            dataIndex: 'investigationSiteCode',
            key: 'investigationSiteCode',
            fixed: 'left',
            width: 100,
            sorter: true,
        }, {
            title: '中心名称',
            dataIndex: 'investigationSiteName',
            key: 'investigationSiteName',
            fixed: 'left',
            width: 120,
            sorter: true,
        }, {
            title: '区域',
            dataIndex: 'areaName',
            key: 'areaName',
            width: 80,
        }, {
            title: '城市',
            dataIndex: 'cityName',
            key: 'cityName',
            width: 80,
        }];
        if (treeData && treeData.length > 0) {
            treeData.forEach(item => {
                const params = { title: item.ssuModuleStructureDefineName };
                if (item.children && item.children.length > 0) {
                    const array = [];
                    item.children.forEach(i => {
                        array.push({
                            title: i.ssuModuleStructureDefineName,
                            dataIndex: i.ssuModuleStructureDefineId,
                            key: i.ssuModuleStructureDefineId,
                            width: 120,
                        })
                    });
                    params.children = array;
                }
                columns.push(params);
            });
        }
        columns.push({
            title: '操作',
            dataIndex: 'operation',
            key: 'operation',
            fixed: 'right',
            width: 110,
            render: (text, record) => {
                return (
                    <span>
                        {
                            (curRole == 'PA' || curRole == 'PM') &&
                            <span>
                                <a onClick={() => this.canEditByInvStatus(() => this.modify(record))}>编辑</a>
                                <span className="ant-divider" />
                            </span>
                        }
                        <a onClick={() => this.showWorkFlow(record)}>办事流程</a>
                    </span>
                );
            }
        });
        return columns;
    }

    getDataSource = () => {
        const { data = [] } = this.state;
        const dataSource = [];
        if (data && data.length > 0) {
            data.forEach(item => {
                const params = {
                    hospitalId: item.hospitalId,
                    investigationSiteId: item.investigationSiteId,
                    investigationSiteCode: item.investigationSiteCode,
                    investigationSiteName: item.investigationSiteName,
                    areaName: item.areaName,
                    cityName: item.cityName,
                    cancelStr: item.cancelStr,
                };
                if (item.ssuModuleStructureDefineList && item.ssuModuleStructureDefineList.length > 0) {
                    item.ssuModuleStructureDefineList.forEach(i => {
                        if (i.value && i.ssuModuleStructureDefineWebType == 'TEXT_RADIO') {
                            const option = i.ssuModuleStructureDefineOptionList.find(child => child.ssuModuleStructureDefineOptionId == i.value) || {};
                            params[i.ssuModuleStructureDefineId] = option.ssuModuleStructureDefineOptionName;
                        } else {
                            params[i.ssuModuleStructureDefineId] = i.value;
                        }
                    });
                }
                dataSource.push(params);
            });
        }
        return dataSource;
    }

    handleTableChange = (pagination, filters, sorter) => {
        const { sortParams } = this.state;
        sortParams.sort = sorter.field ;
        sortParams.direction = sorter.order ? sorter.order == 'descend' ? 'DESC' : 'ASC' : '';
        this.setState({
            pagination,
            sortParams,
        }, () => {
            this.loadTableData();
        });
    }

    modify = (record) => {
        window.scrollTo(0, 0);
        sessionStorage.hospitalId = record.investigationSiteId;
        sessionStorage.hospitalName = record.investigationSiteName;
        sessionStorage.cancelStr = record.cancelStr;
        window.location.href = `./#/shutOff/siteForm`;
    }

    showWorkFlow = (record) => {
        const { hospitalId = '', hospitalName = '' } = this.state;
        sessionStorage.hospitalId = record ? record.hospitalId : hospitalId;
        sessionStorage.hospitalName = record ? record.investigationSiteName : hospitalName;
        window.location.href = `./#/shutOff/workFlow`;
    }

    export = () => {
        const { searchParams, sortParams, pagination } = this.state;
        const url = API_URL.invShutOff.exportInvestigationSiteClose;
        ExportUtil.export({ ...searchParams, ...sortParams }, pagination, url);
    }

    handleEdit = () => {
        this.setState(prevState => ({
            edit: !prevState.edit,
        }));
    }

    render() {
        const { edit, isSite, pagination, cancelStr } = this.state;
        const columns = this.getColumns();
        let len = 0;
        let scrollX = 490;
        if (columns && columns.length > 0) {
            columns.forEach(item => {
                len += item.children ? item.children.length : 0;
            });
        }
        scrollX += len * 120;
        const { curRole } = sessionStorage;
        const isShow = curRole == 'PM' || curRole == 'PA' || curRole == 'CRC';
        return (
            <div className="content site_start">
                <SideNav selectKey='siteClose' />
                <div className="main">
                    <h1>
                        中心关闭记录
                        <Button type="primary" style={{ float: "right", marginLeft: 10 }} onClick={this.export}>导出</Button>
                        {
                            !isSite &&
                            <Button
                                type="primary"
                                style={{ float: "right", background: '#62cf96', borderColor: '#62cf96' }}
                                onClick={() => this.showWorkFlow()}
                            >办事流程</Button>
                        }
                        {
                            (isShow && !isSite) && cancelStr !== '是' &&
                            <Button
                                key="edit"
                                type="primary"
                                style={{ float: "right", marginRight: 10 }}
                                onClick={() => this.canEditByInvStatus(this.handleEdit)}
                                disabled={edit}
                            >编辑</Button>
                        }
                    </h1>
                    {
                        !isSite ?
                            <SiteTemplate edit={edit} changeEdit={this.handleEdit} ssuModuleStructureId={14} />
                        :
                            <div style={{ marginTop: 10 }}>
                                <Table
                                    scroll={{ x: scrollX }}
                                    columns={columns}
                                    dataSource={this.getDataSource()}
                                    rowKey={row => row.investigationSiteId}
                                    onChange={this.handleTableChange}
                                    pagination={pagination}
                                />
                            </div>
                    }
                </div>
            </div>
        )
    }
}

export default SiteClose;


// WEBPACK FOOTER //
// ./src/components/invShutOff/siteClose/index.js